import { lazy, Suspense } from "react";
import { PageSkeleton } from "../../../customs/skeleton/main";

const Main = lazy(() => import("../../../components/settings/learningTraining/events/main"));

const Event = () => {
  return (
      
        <Suspense fallback={<PageSkeleton />}>
          <Main />
        </Suspense>
  );
};

export default Event;

